import { forwardRef, useEffect } from "react"
import { useNavigation } from "./Root"
import { CSSFn } from "../styles"
import { StyledLink } from "./styles/LinkStyle"

interface LinkOwnProps {
  value: string
  external?: boolean
  isDefault?: boolean
  css?: CSSFn
  heading?: boolean
  pathname: string
  closeMenu?: () => void
  setNavTriggered: (triggered: boolean) => void
}

export type LinkProps = React.ComponentPropsWithRef<typeof StyledLink> & LinkOwnProps
export const Link: React.FC<LinkProps> = forwardRef(
  (
    {
      value,
      external = false,
      isDefault = false,
      heading = false,
      pathname,
      closeMenu,
      setNavTriggered,
      ...linkProps
    }: LinkProps,
    forwardedRef
  ) => {
    const { state, dispatch } = useNavigation(`Link`)
    const isHome = value === `/`
    const valueUrlMapping = isHome ? value : `/${value}`
    const isAddVehiclesLink = state.value.includes(`/add`)

    let isActive: boolean = false
    switch (true) {
      case isHome:
        isActive = state.value === valueUrlMapping
        break
      case isDefault:
        isActive = state.value === `/` || state.value.includes(valueUrlMapping)
        break
      case state.value.includes(valueUrlMapping):
        isActive = state.value.includes(valueUrlMapping)
        break
      case isAddVehiclesLink:
        isActive = valueUrlMapping.includes(`fleet`)
        break
      default:
        isActive = false
    }
    useEffect(() => {
      dispatch({ type: `navigate`, value: pathname })
    }, [dispatch, pathname])

    const handleClick = (e: any) => {
      if (closeMenu) closeMenu()
      if (e.altKey) {
        window.open(`${window.location.origin}/${value}`, `_blank`, `noopener noreferrer`)
      } else if (external) {
        window.open(value, `_blank`, `noopener noreferrer`)
      } else {
        setNavTriggered(true)
        dispatch({ type: `navigate`, value: valueUrlMapping })
      }
    }

    return (
      <StyledLink
        {...linkProps}
        ref={forwardedRef}
        variant={heading ? `heading` : `subheading`}
        state={isActive ? `active` : `inactive`}
        data-active={isActive ? `active` : `inactive`}
        onClick={(e: any) => handleClick(e)}
      />
    )
  }
)

Link.defaultProps = {
  external: false,
  isDefault: false,
  heading: false,
  css: undefined,
  closeMenu: undefined,
}
